let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lHxnr")).then(() => parcelRequire('ihebN'));